import { RouterConfig } from '@angular/router';
import { AdminComponent } from './admin.component';
import { UserComponent } from './user.component';
import { AuthGuard } from '../authentication/auth-guard.service';

export const AdminRoutes: RouterConfig = [
  { path: 'admin', component: AdminComponent, canActivate: [AuthGuard] },
  { path: 'user-admin', component: UserComponent, canActivate: [AuthGuard] },
  { path: 'user-admin/:id', component:  UserComponent, canActivate: [AuthGuard] }
];




/** WEBPACK FOOTER **
 ** ./app/administration/admin.routes.ts
 **/